<template>
  <div
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
      v-bind:style="{ 'background-image': 'url(' + imagenFondo + ') !important' }"
  >
  <img
      v-if="ingresoLogo"
      :src="ingresoLogo.imagen"
      id="logo"
      v-bind:style="logoStyle"
  />
  <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
  <vx-card>
  <div
      slot="no-body"
      class="full-page-bg-color"
  >
  <div class="row no-gutter justify-center items-center">

  <div class="col-lg-6 col-md-12">
    <img
        v-if="isImage"
        :src="imagenIngreso"
        alt="login"
        class="mx-auto"
    > <img
      v-if="!isImage"
      src="@/assets/images/pages/login.png"
      alt="login"
      class="mx-auto"
  >
  </div>

  <div class="col-lg-6 col-md-12 d-theme-dark-bg">
  <div class="p-8 login-tabs-container">
  <div
      class="vx-card__title mb-10"
      v-if="!forgotPassword && !fase2fa"
  >
    <h4
        class="mb-4"
        v-html="tituloIngreso"
    ></h4>
    <p v-html="textoHtml"></p>
  </div>
  <div
      class="vx-card__title mb-10"
      v-if="forgotPassword"
  >
    <h4 class="mb-4">Resetear Contraseña</h4>
    <p>
      Ingresa tu correo electrónico y te enviaremos
      las instrucciones para obtener una nueva contraseña
    </p>
  </div>
  <!-- Fase 2FA: validacion del codigo OTP tras las credenciales (codigo == 11) -->
  <div
      v-if="fase2fa"
      class="login-tabs-container"
  >
    <div class="vx-card__title mb-6">
      <h4 class="mb-4">Verificación en dos pasos</h4>
      <p v-if="metodo2fa === 'EMAIL'">
        Ingresa el código que enviamos a <b>{{ correoOfuscado }}</b>
      </p>
      <p v-else-if="metodo2fa === 'TOTP'">
        Ingresa el código de tu aplicación autenticadora
      </p>
      <p v-else>
        Ingresa el código de verificación
      </p>
    </div>
    <otp-input
        ref="otpInput"
        v-model="otp"
        :disabled="verificando"
        :has-error="otpError"
        @complete="verificar2fa()"
    />
    <vs-button
        class="w-full mt-8 btn-ingresar"
        :disabled="otp.length < otpLength || verificando"
        data-cy="verify-otp"
        v-on:click="verificar2fa()"
    >
      Verificar
    </vs-button>
    <div
        v-if="metodo2fa === 'EMAIL'"
        class="text-center mt-5"
    >
      <b-button
          variant="flat-primary"
          :disabled="reenviando || cooldownRestante > 0"
          data-cy="resend-otp"
          @click="reenviarCodigo()"
      >
        <b-spinner
            v-if="reenviando"
            small
            class="mr-1"
        />
        <span v-if="reenviando">Reenviando...</span>
        <span v-else-if="cooldownRestante > 0">Reenviar código en {{ cooldownRestante }}s</span>
        <span v-else>Reenviar código</span>
      </b-button>
    </div>
    <div class="text-center mt-3">
      <b-button
          variant="flat-secondary"
          data-cy="back-from-otp"
          @click="cancelar2fa()"
      >
        Volver
      </b-button>
    </div>
  </div>
  <form
      v-if="!forgotPassword && !fase2fa"
      ref="form"
      data-vv-scope="form"
      @submit.prevent="attemptSignIn()"
  >
    <vs-input
        name="correo"
        data-cy="mail"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        :label-placeholder="nombreCampoUsuario"
        v-model="correo"
        class="w-full"
        v-validate="'required|email'"
        :danger="errors.has('form.correo')"
        :danger-text="errors.first('form.correo')"
        @keyup.enter.native="attemptSignIn()"
    />
    <vs-input
        type="password"
        name="clave"
        data-cy="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        :label-placeholder="nombreCampoClave"
        v-model="clave"
        class="w-full mt-8"
        required
        v-validate="'required'"
        :danger="errors.has('form.clave')"
        :danger-text="errors.first('form.clave')"
        @keyup.enter.native="attemptSignIn()"
    />
    <div class="flex flex-wrap justify-between my-5">
      <vs-checkbox
          v-if="product !== 'ed'"
          v-model="recordar"
          class="mb-3"
      >
        Recordar mi usuario
      </vs-checkbox>
      <b-button
          variant="flat-secondary"
          @click="iForgotThePassToggle"
      >
        ¿Olvidaste tu contraseña?
      </b-button>
    </div>
    <vs-button
        type="border"
        v-if="botonRegistroProveedor && product !== 'ed'"
    >
      {{ nombreBotonRegistroProveedores }}
    </vs-button>
    <vs-button
        class="float-right btn-ingresar mb-10"
        style="margin-top:20px"
        v-on:click="attemptSignIn()"
        data-cy="get-in"
    >
      {{ nombreBotonIngreso }}
    </vs-button>
    <div
        id="clave-unica"
        v-if="botonClaveUnica || botonGoogle"
    >
      <vs-divider>O</vs-divider>
    </div>
    <div
      id="clave-unica"
      v-if="botonClaveUnica"
    >
      También puedes ingresar con <B>Clave Única</B> del <B>Registro Civil</B>
      <div
        class="flex flex-wrap mt-5 justify-center"
      >
        <button-clave-unica
          size="md"
          @click="redirectToClaveUnica()"
          full-width
        />
      </div>
    </div>
    <div
        id="federate-auth"
        v-if="botonGoogle"
    >
      <div
          class="flex flex-wrap mt-5 federate-auth"
          v-on:click="redirectToEntity('google')"
      >
        <div
            id="customBtn"
            class="google-btn btn btn-default"
        >
          <span class="icon-google"></span> <span class="buttonText">Ingresa con Google</span>
        </div>
      </div>
    </div>
  </form>
  <div
      class="login-tabs-container"
      v-if="forgotPassword"
  >
    <forgot-password @close="iForgotThePassToggle"/>
  </div>
  </div>
  </div>
  </div>
  </div>
  </vx-card>
  </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import I18nMixin from '@/febos/global/_vue/mixins/I18nMixin';
import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';
import ForgotPassword from '@/febos/global/usuario/components/ForgotPassword';
import ButtonClaveUnica from '@/components/ButtonClaveUnica';
import OtpInput from '@/components/inputs/OtpInput';

const OTP_LENGTH = 6;
const COOLDOWN_REENVIO_SEGUNDOS = 60;

export default {
  mixins: [I18nMixin, PersonalizacionMixin],
  components: { ForgotPassword, ButtonClaveUnica, OtpInput },
  data() {
    return {
      fileExtensions: ['png', 'jpg', 'svg'],
      forgotPassword: false,
      product: process.env.VUE_APP_PRODUCTO,
      correo: '',
      clave: '',
      recordar: false,
      keyRecordar: `${process.env.VUE_APP_CODIGO_PAIS}.${process.env.VUE_APP_PORTAL}.${process.env.VUE_APP_AMBIENTE}.correo`,
      // --- Estado del flujo 2FA de dos pasos ---
      fase2fa: false,
      metodo2fa: null,
      desafioId: null,
      correoOfuscado: null,
      otp: '',
      otpLength: OTP_LENGTH,
      otpError: false,
      verificando: false,
      reenviando: false,
      cooldownRestante: 0,
      cooldownTimer: null
    };
  },
  beforeDestroy() {
    this.detenerCooldown();
  },
  mounted() {
    this.closeModal();
    if (localStorage.getItem(this.keyRecordar)) {
      this.correo = localStorage.getItem(this.keyRecordar);
      if (this.correo !== '') {
        this.recordar = true;
      }
    }
    this.attemptLoadSettings();
    this.forgotPassword = false;
  },
  methods: {
    ...mapActions('Usuario', ['signIn']),
    ...mapActions('Modals', ['closeModal']),
    iForgotThePassToggle() {
      this.forgotPassword = !this.forgotPassword;
    },
    async attemptSignIn() {
      const result = await this.$validator.validateAll('form');

      if (!result) {
        return;
      }

      if (this.recordar) {
        localStorage.setItem(this.keyRecordar, this.correo);
      } else {
        localStorage.setItem(this.keyRecordar, '');
      }

      this.$vs.loading();

      try {
        const login = await this.signIn({
          correo: this.correo,
          clave: this.clave
        });

        // El backend solicito el segundo factor: mostramos la vista de OTP
        // sin navegar ni cerrar sesion.
        if (login.requiere2fa) {
          this.iniciarFase2fa(login);
          return;
        }

        await this.redirigirPostLogin(login);
      } catch (error) {
        this.mostrarError(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    /**
     * Valida el OTP (paso B): reenvia credenciales + { otp, desafioId }.
     */
    async verificar2fa() {
      if (this.verificando || this.reenviando) {
        return;
      }
      if (!this.otp || this.otp.length !== this.otpLength) {
        return;
      }

      this.verificando = true;
      this.otpError = false;
      this.$vs.loading();

      try {
        const login = await this.signIn({
          correo: this.correo,
          clave: this.clave,
          otp: this.otp,
          desafioId: this.desafioId
        });

        // Un nuevo desafio (codigo 11) tras intentar validar: refrescamos estado.
        if (login.requiere2fa) {
          this.iniciarFase2fa(login);
          return;
        }

        await this.redirigirPostLogin(login);
      } catch (error) {
        // Mantener la fase 2FA y permitir reintentar el codigo.
        this.otp = '';
        this.otpError = true;
        this.$nextTick(() => {
          if (this.$refs.otpInput) {
            this.$refs.otpInput.focusFirst();
          }
        });
        this.mostrarError(error);
      } finally {
        this.verificando = false;
        this.$vs.loading.close();
      }
    },
    /**
     * Reenvia el codigo (solo metodo EMAIL): repite el paso A sin otp/desafioId.
     * Respeta el cooldown local coherente con el backend.
     */
    async reenviarCodigo() {
      if (this.reenviando || this.verificando || this.cooldownRestante > 0) {
        return;
      }

      this.reenviando = true;

      try {
        const login = await this.signIn({
          correo: this.correo,
          clave: this.clave
        });

        if (login.requiere2fa) {
          this.iniciarFase2fa(login);
        } else {
          // El backend ya no exige 2FA: completar login.
          await this.redirigirPostLogin(login);
        }
      } catch (error) {
        // Un error (p.ej. cooldown del backend) NO debe sacar al usuario de la vista OTP.
        this.mostrarError(error);
      } finally {
        this.reenviando = false;
      }
    },
    /**
     * Cancela el flujo 2FA y vuelve al formulario de credenciales.
     */
    cancelar2fa() {
      this.fase2fa = false;
      this.metodo2fa = null;
      this.desafioId = null;
      this.correoOfuscado = null;
      this.otp = '';
      this.otpError = false;
      this.detenerCooldown();
    },
    /**
     * Entra (o refresca) la fase de validacion del OTP con los datos del backend.
     */
    iniciarFase2fa({ metodo, desafioId, correoOfuscado }) {
      this.metodo2fa = metodo;
      this.desafioId = desafioId;
      this.correoOfuscado = correoOfuscado;
      this.otp = '';
      this.otpError = false;
      this.fase2fa = true;

      // Solo el metodo EMAIL permite reenviar; arrancamos el cooldown al recibir el codigo.
      if (metodo === 'EMAIL') {
        this.iniciarCooldown();
      } else {
        this.detenerCooldown();
      }

      this.$nextTick(() => {
        if (this.$refs.otpInput) {
          this.$refs.otpInput.focusFirst();
        }
      });
    },
    async redirigirPostLogin(login) {
      // Login exitoso: limpiar estado 2FA por si venimos del paso B.
      this.cancelar2fa();
      if (login.usuario.cambiarClave) {
        await this.$router.push({ name: 'updatePassword' });
      } else {
        await this.$router.push({ name: 'iniciando' });
      }
    },
    mostrarError(error) {
      this.$vs.dialog({
        color: 'danger',
        title: 'Ups!',
        text: `${error.message}`,
        acceptText: 'Ok'
      });
    },
    iniciarCooldown() {
      this.detenerCooldown();
      this.cooldownRestante = COOLDOWN_REENVIO_SEGUNDOS;
      if (this.cooldownRestante <= 0) {
        return;
      }
      this.cooldownTimer = setInterval(() => {
        this.cooldownRestante -= 1;
        if (this.cooldownRestante <= 0) {
          this.detenerCooldown();
        }
      }, 1000);
    },
    detenerCooldown() {
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
        this.cooldownTimer = null;
      }
      this.cooldownRestante = 0;
    },
    async redirectToEntity(entidad) {
      this.$vs.loading();
      const domain = window.location.href.replace('https://', '').replace('http://', '').split('/');
      const app = process.env.VUE_APP_PORTAL;
      const urlOk = encodeURIComponent(
        `https://${domain[0]}/${app}/verificando?estado=ok&idProceso={id_proceso}&seguimiento={seguimiento}`
      );
      const urlError = encodeURIComponent(
        `https://${domain[0]}/${app}/verificando?estado=error&idProceso={id_proceso}&seguimiento={seguimiento}`
      );
      return window.open(
        `https://api.febos.cl/${process.env.VUE_APP_AMBIENTE}/usuarios/sso/?entidad=${entidad}&empresa=${this.empresaPortal}&dominioPortal=${domain[0]}&urlCallback=${urlOk}&urlCallbackError=${urlError}`,
        '_self'
      );
    },
    async redirectToClaveUnica() {
      this.$vs.loading();
      const domain = window.location.href.replace('https://', '').replace('http://', '').split('/');
      const app = process.env.VUE_APP_PORTAL;
      const urlOk = encodeURIComponent(
        `https://${domain[0]}/${app}/verificando/claveunica?estado=ok&idProceso={id_proceso}&seguimiento={seguimiento}`
      );
      const urlError = encodeURIComponent(
        `https://${domain[0]}/${app}/verificando/claveunica?estado=error&idProceso={id_proceso}&seguimiento={seguimiento}`
      );
      return window.open(
        `https://api.febos.cl/${process.env.VUE_APP_AMBIENTE}/usuarios/sso/claveunica?empresa=${this.empresaPortal}&dominioPortal=${domain[0]}&urlCallback=${urlOk}&urlCallbackError=${urlError}`,
        '_self'
      );
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .clave-unica {
    display: block;
    margin: 0 auto;
  }
  .btn-cu {
    /*display: inline-block;*/
    display: flex;
    justify-content: center;
    font-family: Roboto, sans-serif;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-radius: 0;
  }
  .btn-cu.btn-m {
    width: 160px;
    min-width: 160px;
    height: 42px;
    padding: 8px 18px 8px 15px !important;
    font-size: 16px;
    line-height: 1.6em;
  }
  .btn-cu.btn-color-estandar {
    background-color: #0F69C4;
    color: #FFF;
  }
  .btn-cu.btn-color-estandar:hover {
    background-color: #0C549C;
    color: #FFF;
  }

  .btn-cu.btn-color-estandar:active {
    background-color: #093F75;
    color: #FFF;
  }

  .btn-cu.btn-color-estandar:focus {
    background-color: #0C549C;
    color: #FFF;
    outline: 1px dashed #000;
  }
  .btn-cu .texto {
    padding-left: 3px;
  }

  .federate-auth {
    align-content: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
  }

  .google-btn {
    border-radius: 5px;

    &:hover {
      background-color: #fff;
      border: 1px solid #dcdcdc;
    }
  }

  span.icon-google {
    background: url('~@/assets/images/logo/g-normal.png') transparent 5px 50% no-repeat;
    display: inline-block;
    vertical-align: middle;
    width: 42px;
    height: 42px;
  }
}
</style>
